import AuthLayout from "../pages/Dashboard/Pages/AuthLayout.vue";

// Pages
import Login from "../pages/Dashboard/Pages/Login.vue";

let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "*",
            name: "Login",
            component: Login
        },
    ]
};

const routes = [
    authPages
];

export default routes;
